"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _material = require("@mui/material");

var _constants = require("../../constants");

var _common = require("../../common");

var _BrandSelect = _interopRequireDefault(require("../BrandSelect"));

var _BrandInputLabel = _interopRequireDefault(require("../BrandInputLabel"));

var _MotivatorOptionLabel = _interopRequireDefault(require("./MotivatorOptionLabel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MotivatorSelector = function MotivatorSelector(_ref) {
  var scale_id = _ref.scale_id,
      handleChange = _ref.handleChange,
      disabled = _ref.disabled;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var options = Object.keys(_constants.SCALES_BY_ID).sort(function (a_scale_id, b_scale_id) {
    return _constants.SCALES_BY_ID[a_scale_id].localeCompare(_constants.SCALES_BY_ID[b_scale_id]);
  }).map(function (scale_id2, idx) {
    return {
      value: scale_id2,
      label: /*#__PURE__*/_react.default.createElement(_MotivatorOptionLabel.default, {
        scale_id: scale_id2,
        idx: idx
      })
    };
  });
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_BrandInputLabel.default, {
    label: (0, _common.capitalize)(t('motivator')),
    fontSize: "xl",
    fontWeight: "bold"
  }), /*#__PURE__*/_react.default.createElement(_BrandSelect.default, {
    onChange: function onChange(val) {
      return handleChange(val);
    },
    options: options,
    value: scale_id || '',
    disabled: disabled,
    placeholder: (0, _common.capitalize)(t('select_motivator'))
  }));
};

var _default = MotivatorSelector;
exports.default = _default;